import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ViewMisService } from './view-mis.service';
import { AuthService } from 'app/laas/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AddCustomerService } from '../add-customer/add-customer.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AdminAuthService } from '../admin-auth.service';
import * as moment from 'moment';
import { AdminService } from '../admin.service';
import * as FileSaver from 'file-saver';
import { OpenAdminDialogYesOrNo } from '../admin-yes-or-no/admin-yes-or-no.component';
import { DatePipe } from '@angular/common';
import * as constants from '../../../app/constant'


@Component({
  selector: "wl-loader-dialog",
  template: `
    <div style="display:flex;flex-direction:column;justify-content:center;align-items:center;">
      <i
        class="fa fa-spinner fa-pulse fa-2x fa-fw"
        style="color:#506c84;margin:0 auto;display:block;"
      ></i>
      <p>Loading Data For the First time.. Please Wait..</p>
    </div>
  `,
})
export class LoaderDialogOnlineComponent {
  message: string;

  constructor(
    // public dialogRef: MatDialogRef<LoaderDialogComponent>
    public bsModalRef: BsModalRef
  ) { }
}

@Component({
  selector: "wl-view-mis",
  templateUrl: "./view-mis.component.html",
  styleUrls: [
    "./view-mis.component.scss"
  ],
  providers: [ViewMisService, AddCustomerService, AdminService, DatePipe]
})
export class ViewMisComponent implements OnInit {
  allUsers: Observable<any>;
  isDataPending: boolean;
  search = new UntypedFormControl();
  rocCount: number;
  credCount: number;
  page: number = 1;
  totalPage: number = 1;
  totalCount: number;
  noUserFound: string;
  reportLink: string;
  adminId: any;
  custId: any;
  iscredCount: boolean;
  showOrHide: boolean;
  placeHolder: string;
  searchHolder: string;
  roleId: string;
  limit: number = 10;
  offset: number = 0;

  userName: string;
  display: boolean;
  typeText: string;
  misForm: UntypedFormGroup;
  type: any;
  bsModalRef: BsModalRef;
  isRetail: boolean;
  makerOnly: boolean = true;
  pageId: any = 1;
  @ViewChild("date1") firstDate: ElementRef;
  startDate: any;
  endDate: any;
  accessName: any = [];
  jsonString: string;
  base64str: string = "";
  selectedState: string;
  routeApiIdentifier: string = 'wEnlw3OeU3';
  routeApiKeys: Array<any> = [
    {
      value: 'MP',
      key: 'xmpHUKBVNVSFG61XnJAzKOQ32EWjSdE1',
    },
    {
      value: 'KA',
      key: 'KDw2nS6vb5cJ286KJ3JwtGKGnnnLO93Y',
    },
    {
      value: 'AP',
      key: 'X0ZUk5Z7otQSnJFm9rc2bcAvwPrp66i6',
    },
    {
      value: 'UP',
      key: 'Uq4YVODcoCruRMHy8lCFRPFbAf8d4uP8',
    },
    {
      value: 'OD',
      key: '2HeSroDFbNjOyhnwVO4WV90Gu2ET1QsZ',
    },
    {
      value: 'TN',
      key:'tNteP4U71cOhlWNlpGF5F9vkWkUFtmMy'
    },
    {
      value: 'AD',
      key: 'X0ZUk5Z7otQSnJFm9rc2bcAvwPrp66i6'
    },
    {
      value: 'RJ',
      key: 'Rs3dWqiFcIvLvRNFneH8wSRduQF28UhJ'
    },
    {
      value: 'GJ',
      key: 'gXpj9Y7qw1U5Jp6tdn4vkqduvnMZEjJJ'
    },
    {
      value: 'MH',
      key: 'fPWMHrmB1qRhPu2bOIT9LlGcAugp8cM6'
    }

  ];
  misTypes: any = [
    "BRE STATUS",
    "ACCOUNTS RENEWED IN CBS",
    "CROSS SELL REPORT",
    "ACCOUNTS NOT SENT TO CBS",
    "ACCOUNTS SENT TO CBS",
    "BRANCH REPORT FULL",
    /* "STATUS TRACKER REPORT", */
    "SUMMARY REPORT",
    "CBS MISSING DATA REPORT",
  ];

  states: Array<any> = [
    // { code: 'ALL_STATES', name: 'All States' }, Not Supported as of now
    { code: 'KA', name: 'Karnataka' },
    { code: 'MP', name: 'Madhya Pradesh' },
    // { code: 'UP', name: 'Uttar Pradesh' },
    // { code: 'AP', name: 'Andhra Pradesh' },  
  ];

  statesFresh: Array<any> = [
    // { code: 'ALL_STATES', name: 'All States' }, Not Supported as of now
    { code: 'KA', name: 'Karnataka' },
    { code: 'MP', name: 'Madhya Pradesh' },
    { code: 'UP', name: 'Uttar Pradesh' },
    {code: 'OD', name: 'Odisha'},
    {code:'TN', name: 'Tamilnadu'},
    { code: 'AD', name: 'Andhra Pradesh' },
    { code: 'RJ', name: 'Rajasthan'},
    { code: 'GJ', name: 'Gujarat' },
    { code: 'MH', name: 'Maharashtra'},
  ];
  statesRenewal: Array<any> = [
    // { code: 'ALL_STATES', name: 'All States' }, Not Supported as of now
    { code: 'KA', name: 'Karnataka' },
    { code: 'MP', name: 'Madhya Pradesh' },
    // { code: 'AP', name: 'Andhra Pradesh' },
  ];

  misTypesFreshWithoutInvoice: any = [
    "NESL RECONCILIATION",
    "CIC RECONCILIATION",
    "SUMMARY REPORT - DIGITAL KCC",
    "SUMMARY REPORT - BRANCH-WISE",
    "CHARGE CREATION REPORT",
    "DETAILED REPORT - REF.NO WISE",
    "DETAILED REPORT - LOAN A/C OPENED",
    "ASSISTED JOURNEY REPORT"
  ];
  misTypesFreshWithInvoice: any = [
    "NESL RECONCILIATION",
    "CIC RECONCILIATION",
    "SUMMARY REPORT - DIGITAL KCC",
    "SUMMARY REPORT - BRANCH-WISE",
    "CHARGE CREATION REPORT",
    "DETAILED REPORT - REF.NO WISE",
    "DETAILED REPORT - LOAN A/C OPENED",
    "ASSISTED JOURNEY REPORT",
    "FRESH CASES INVOICE",
    "KCC FRESH DETAILED REPORT"
  ];
  misTypesFresh:any = [];
  misTypesRenewalWithoutInvoice: any = [
    "CIC RECONCILIATION",
    "DETAILED KCC RENEWAL REPORT",
    "ADDITIONAL SOF BY ACCOUNT",
    "KCC RENEWAL BY BRANCH",
    "ADDITIONAL SOF BY RO"
  ];
  misTypesRenewalWithInvoice: any = [
    "CIC RECONCILIATION",
    "DETAILED KCC RENEWAL REPORT",
    "ADDITIONAL SOF BY ACCOUNT",
    "KCC RENEWAL BY BRANCH",
    "ADDITIONAL SOF BY RO",
    "RENEWAL CASES INVOICE"
  ];
  misTypesRenewal:any = [];
  showDropDown: boolean = true;
  dist: any;
  options: any;
  codePlaceholder: string = " Enter Zone/Region/Branch";
  coSelected: boolean;
  disableCodeDropdown: boolean = true;
  enableMisType: boolean = false; // Type of MIS dropdown enabled only after ZRB API response
  loading: boolean;
  zrbCode: any;
  makerRoleId: string = "11";
  checkerRoleId: string = "12";
  showSpinner: boolean = false;
  showTypeNCodeSelection: boolean = true;
  renewPage: boolean = false;
  freshPage: boolean = false;
  subheading1: string;
  subheading2: string;
  maxDate: string;
  myDate = new Date();
  isCO: boolean = false;
  hideZrbListDropDown: boolean = false;

  constructor(
    private customer: ViewMisService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private fb: UntypedFormBuilder,
    private adminservice: AdminService,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe
  ) {
    this.maxDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    console.log('date', this.maxDate);
    this.misForm = this.fb.group(
      {
        organisationName: ["", [Validators.required]],
        misTypes: ["", [Validators.required]],
        date1: ["", [Validators.required]],
        date2: ["", [Validators.required]],
        code: ["", [Validators.required]],
        branchName: [""],
        state: [""]
      },
      { validator: this.dateRangeValidator }
    );
  }

  dateRangeValidator(control: AbstractControl) {
    const fromDate = control.get("date1") ? control.get("date1").value : "";
    const toDate = control.get("date2") ? control.get("date2").value : "";
    const minDate = "2022-01-01";
    const today = new Date();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    const maxDate = `${today.getFullYear()}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`;

    if (fromDate && toDate && fromDate > toDate) {
      return { dateRangeInvalid: true };
    }

    if ((fromDate && (fromDate < minDate || fromDate > maxDate)) ||
      (toDate && (toDate < minDate || toDate > maxDate))) {
      return { invalidDate: true };
    }

    return null;
  }

  isDateRangeInvalid(): boolean {
    return !!(this.misForm &&
      this.misForm.hasError("dateRangeInvalid") &&
      this.misForm.get("date1").value &&
      this.misForm.get("date2").value);
  }

  isFutureOrOutOfRangeDateInvalid(): boolean {
    return !!(this.misForm && this.misForm.hasError("invalidDate"));
  }

  selectOrganisationEvent(e) {
    console.log(e.value);
    this.organisationName.setValue(e.target.value, {
      onlySelf: true,
    });
  }

  get organisationName() {
    return this.misForm.get("organisationName");
  }

  // Organisation Level is accessible only once a state is selected (CO users only;
  // non-CO users have no state step, so it stays enabled for them).
  get isOrgLevelEnabled(): boolean {
    if (!this.isCO) {
      return true;
    }
    return !!this.selectedState;
  }

  // Type of MIS is accessible only once the previous (Zone/Region/Branch) field is filled.
  get isMisTypeEnabled(): boolean {
    // Branch-level users have no organisation-level / ZRB step, so nothing to wait for.
    if (!this.showTypeNCodeSelection) {
      return true;
    }
    // Roles where the ZRB list is hidden (code is derived from the logged-in office):
    // enable once the ZRB data has loaded.
    if (this.hideZrbListDropDown) {
      return this.enableMisType;
    }
    // Normal flow: the Zone/Region/Branch office (code) must be selected first.
    var codeCtrl = this.misForm.get("code");
    return !!(codeCtrl && codeCtrl.value);
  }

  ngOnInit() {
    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();
    this.roleId = sessionStorage.getItem("getroleId");
    console.log(window.location.href)
    let url = window.location.href;
    if (url.split('/')[url.split('/').length - 1] == "mis") {
      if(this.roleId == "0" || this.roleId == "1"){
        this.misTypes = this.misTypesRenewalWithInvoice;
      }else{
        this.misTypes = this.misTypesRenewalWithoutInvoice;
      }
      this.misTypesRenewal = this.misTypes;

    } else {
      if(this.roleId == "0" || this.roleId == "1"){
        this.misTypes = this.misTypesFreshWithInvoice;
      }else{
        this.misTypes = this.misTypesFreshWithoutInvoice;
      }
      this.misTypesFresh = this.misTypes;

    }

    // window.alert(window.location.href)
    let currentUrl = window.location.href;
    // window.alert(currentUrl.split('/')[currentUrl.split('/').length-2])
    let path = currentUrl.split('/')[currentUrl.split('/').length-2]
    if(path=="fresh-app"){
      this.states = this.statesFresh;
    }else if(path=="admin"){
      
    }

    /* this.getZoneCode() */
    this.misForm.statusChanges.subscribe((change) => {
      console.log(change, this.misForm.value);
      
    });


    console.log("this.roleId " + this.roleId);

    this.adminId = sessionStorage.getItem("wl-admin-id");

    let role = sessionStorage.getItem("getroleId");
    if(role == '0' || role == '1'){
      this.isCO = true;
    }
    if (
      role == "0" ||
      role == "1" ||
      role == "7" ||
      role == "8" ||
      role == this.makerRoleId ||
      role == this.checkerRoleId
    ) {
      this.accessName = [
        { name: "Central Office", value: "CO" },
        { name: "Zonal", value: "Zone" },
        { name: "Regional", value: "RO" },
        { name: "Branch", value: "Branch" },
      ];
    } else if (role == "2") {
      this.accessName = [
        // { name: "Central Office", value: "CO" },
        { name: "Zonal", value: "Zone" },
        { name: "Regional", value: "RO" },
        { name: "Branch", value: "Branch" }]
    } else if (role == '2' || role == '21') {
      this.accessName = [{ name: "Zonal", value: "Zone" },
      { name: "Regional", value: "RO" },
      { name: "Branch", value: "Branch" }]
    } else if (role == '3' || role == '31') {
      this.accessName = [{ name: "Regional", value: "RO" },
      { name: "Branch", value: "Branch" }]
    } else if (role == '4' || role == '5' || role == '41') {
      this.accessName = [{ name: "Branch", value: "Branch" }];
      this.showTypeNCodeSelection = false;
      this.misForm.controls['organisationName'].setValidators([]);
      this.misForm.controls['code'].setValidators([])
      /* this.showDropDown = false; */
    }
  }

  getZoneCode() {
    console.log("zone select", this.adminservice.zoneSelection);
    this.adminservice
      .getOfficeCode(this.adminservice.zoneSelection)
      .subscribe((response) => {
        console.log("our response", response);
        if (response && response.success && response.result) {
          this.dist = response.result;
          let newDist = this.dist.map((obj) => {
            let objct = {};
            if (this.adminservice.zoneSelection == "Zone") {
              objct["id"] = obj.zone_name;
              objct["name"] = obj.zone_name;
              objct["code"] = obj.zone_code;
              console.log("zone correct cond");
            }
            if (this.adminservice.zoneSelection == "RO") {
              objct["id"] = obj.ro_name;
              objct["name"] = obj.ro_name;
              objct["code"] = obj.ro_code;
              console.log("RO correct cond");
            }
            if (this.adminservice.zoneSelection == "Branch") {
              objct["id"] = obj.branch_name;
              objct["name"] = obj.branch_name;
              objct["code"] = obj.branch_code;
              console.log("Branch correct cond");
            }
            if (this.adminservice.zoneSelection == "CO") {
              objct["id"] = obj.co_name;
              objct["name"] = obj.co_name;
              objct["code"] = obj.co_code;
              console.log("co correct cond");
            }

            return objct;
          });
          this.options = newDist;
          console.log("dist console", newDist);
        }
      });
  }
  ZRBSelected(event) {
    this.misForm.get("branchName").setValue(event.id);
    this.zrbCode = event.code;
    console.log(this.zrbCode);
  }
  accessSelected(value) {
    this.misForm.controls['code'].setValidators([Validators.required])
    this.hideZrbListDropDown = false;
    console.log("access selected",value)
    this.misForm.get("code").reset();
    this.getDropDownValues(value);

    this.adminservice.zoneSelection = value;
    // this.isCO = false;
    if (value == "CO") {
      this.codePlaceholder = "Enter Office Name";
      this.coSelected = true;
      this.misForm.get("branchName").setValue("");
      // this.isCO = true;
    } else if (value == "Zone") {
      this.codePlaceholder = "Enter Zonal Office Name";
      this.coSelected = false;
      this.misForm.get("branchName").setValue("");
      if(this.roleId == '2' || this.roleId == '21'){
        this.hideZrbListDropDown = true;
        this.misForm.controls['code'].clearValidators();
        this.misForm.controls['code'].setErrors(null);
        this.misForm.controls['code'].setValidators([]);
      }
    } else if (value == "RO") {
      this.codePlaceholder = "Enter Regional Office Name";
      this.coSelected = false;
      this.misForm.get("branchName").setValue("");
      if(this.roleId == '3' || this.roleId == '31'){
        this.hideZrbListDropDown = true;
        this.misForm.controls['code'].clearValidators();
        this.misForm.controls['code'].setErrors(null);
        this.misForm.controls['code'].setValidators([]);
      }
    } else if (value == "Branch") {
      this.codePlaceholder = "Enter Branch Office Name";
      this.coSelected = false;
      this.misForm.get("branchName").setValue("");
    }
  }
  getDropDownValues(type) {
    // debugger
    this.options = []
    this.enableMisType = false; // disable Type of MIS until the ZRB response arrives
    this.loading = true;
    this.type = type;
    console.log(type);
    let data = {};
    data["type"] = type.toLowerCase();
    this.disableCodeDropdown = true;

    if (this.roleId == "0") {
      data["zrbcode"] = null;
    } else if (
      this.roleId == "1" ||
      this.roleId == "11" ||
      this.roleId == "12" ||
      this.roleId == "7" ||
      this.roleId == "8"
    ) {
      data["zrbcode"] = null;
    } else if (this.roleId == "2" || this.roleId == "21") {
      // data['zrbcode'] = sessionStorage.getItem("zonal_code");
      // if(this.misForm.get('organisationName').value.toLowerCase() == 'ro'){
        data['filter'] = "zone";
        data['code_value'] = sessionStorage.getItem("zonal_code");
        data['code_type'] = 'zone_code';
      // }
      // else if(this.misForm.get('organisationName').value.toLowerCase() == 'branch'){
      //   data['filter'] = "zone";
      //   data['code_value'] = sessionStorage.getItem("zonal_code");
      //   data['code_type'] = 'zone_code';
      // }


    } else if (this.roleId == "3" || this.roleId == "31") {
      // data["zrbcode"] = sessionStorage.getItem("ro_code");
      console.log(this.misForm.get('organisationName').value, '------->')
      // if (this.misForm.get('organisationName').value.toLowerCase() == 'branch') {
        data['filter'] = "ro";
        data['code_type'] = 'ro_code';
        data['code_value'] = sessionStorage.getItem("ro_code");
      // }
      
    } 
    // else if (this.roleId == "4" || this.roleId == "41") {
    //   data["zrbcode"] = sessionStorage.getItem("branch_code");
    //   data['filter'] = "branch";
    // }

    // data['filter'] = null;

    // this.customer.getDropDownValues(data).subscribe(

    // debugger
    if (type.toLowerCase() == "co") {
      let objct = {}
      objct["id"] = "Central Office";
      objct["name"] = "Central Office";
      objct["code"] = "57365";
      this.options = [objct]
      console.log("co correct cond");
      // debugger
      this.misForm.patchValue({ code: this.options[0].code });
      this.enableMisType = true; // CO has no ZRB lookup; code is resolved, enable Type of MIS
      this.showSpinner = false;
      this.loading = false;
    }else{
      this.customer.getStateZrbInfo(data).subscribe(
  
        (resp) => {
          this.disableCodeDropdown = false;

          console.log(resp);
          this.loading = false;
          console.log(this.adminservice.zoneSelection)
          // debugger
          if (
            resp && resp.message == "success" &&
             resp.result.length) {
            this.dist = resp.result;
            let newDist = this.dist.map((obj) => {
              let objct = {};
              // debugger
              if (this.adminservice.zoneSelection == "Zone") {
                objct["id"] = obj.zone_name;
                objct["name"] = obj.zone_name;
                objct["code"] = obj.zone_code;
  
                console.log("zone correct cond");
              }
              if (this.adminservice.zoneSelection == "RO") {
                objct["id"] = obj.ro_name;
                objct["name"] = obj.ro_name;
                objct["code"] = obj.ro_code;
  
                console.log("RO correct cond");
              }
              if (this.adminservice.zoneSelection == "Branch") {
                objct["id"] = obj.branch_name;
                objct["name"] = obj.branch_name;
                objct["code"] = obj.branch_code;
  
                console.log("Branch correct cond");
              }
              if (this.adminservice.zoneSelection == "CO") {
  
                objct["id"] = "Central Office";
                objct["name"] = "Central Office";
                objct["code"] = "57365";
  
                console.log("co correct cond");
                this.misForm.patchValue({ code: "Central Office" });
              }
  
              return objct;
            });
            this.options = newDist;
            console.log("dist console", newDist);
            this.disableCodeDropdown = false;
            this.enableMisType = true; // ZRB response received, enable Type of MIS
          } else {
            this.disableCodeDropdown = true;
            this.enableMisType = false;
            this.snackbar.open("No data found", "OK", { duration: 3000 });
          }
        },
        (err) => {
          this.showSpinner = false;
          this.snackbar.open("Something went wrong", "OK", { duration: 3000 });
        }
      );
    }


  }

  runReport(data) {
    this.startDate = data.date1;
    this.endDate = data.date2;
    if (this.isDateRangeInvalid()) {
      this.snackbar.open("From date cannot be greater than To date", "OK", { duration: 3000 });
      return;
    }
    if (this.isFutureOrOutOfRangeDateInvalid()) {
      this.snackbar.open("Please enter valid dates", "OK", { duration: 3000 });
      return;
    }
    if (this.startDate <= this.maxDate && this.startDate >= '2022-01-01' && this.endDate <= this.maxDate && this.endDate >= '2022-01-01') {
      console.log(this.startDate, this.endDate, data)
      let startDate;
      let endDate;
      this.loading = true;
      if (this.startDate && this.startDate.split("-")[0].length > 2) {
        startDate = this.startDate
          ? this.startDate.split("-").reverse().join("-")
          : "";
        endDate = this.endDate ? this.endDate.split("-").reverse().join("-") : "";
      } else {
        startDate = this.startDate ? this.startDate : "";
        endDate = this.endDate ? this.endDate : "";
      }
      let endpoint;

      switch (data.misTypes) {
        case this.misTypesFresh[0]:
          endpoint = "mis/nesl-reconciliation";
          break;

        case this.misTypesRenewal[0]:
        case this.misTypesFresh[1]:
          endpoint = "mis/cic-reconciliation";
          break;

        case this.misTypesFresh[2]:
          endpoint = "mis/summary-digital-kcc-stp";
          break;

        case this.misTypesFresh[3]:
          endpoint = "mis/summary-report-branch-wise";
          break;

        case this.misTypesFresh[4]:
          endpoint = "mis/charge-creation";
          break;

        case this.misTypesFresh[5]:
          endpoint = "mis/detailed-report-refNo-wise";
          break;

        case this.misTypesFresh[6]:
          endpoint = "mis/detailed-report-loan-Ac-opened";
          break;

        case this.misTypesRenewal[1]:
          endpoint = "mis/detailed-kcc-renewal-report";
          break;

        case this.misTypesRenewal[2]:
          endpoint = "mis/additional-sof-account-wise";
          break;

        case this.misTypesRenewal[3]:
          endpoint = "mis/kcc-renewal-branch-wise";
          break;

        case this.misTypesRenewal[4]:
          endpoint = "mis/additional-sof-by-ro";
          break;

        case this.misTypesFresh[7]:
          endpoint = "mis/assisted-journey-report";
          break;

        case this.misTypesFresh[8]:
          endpoint = "mis/fresh-invoices";
          break;

          case this.misTypesFresh[9]:
            endpoint = "mis/kcc-fresh-detailed-report";
            break;
        
        case this.misTypesRenewal[5]:
          endpoint = "mis/renewal-invoice-report";
          break;
      }
      debugger

      data.type = this.adminservice.getCodeAndType().type;
      data[this.adminservice.getCodeAndType().type] = this.adminservice.getCodeAndType().code;
      if (this.startDate && this.endDate) {
        this.customer
          .getfreshcasesreport(
            startDate,
            endDate,
            this.type,
            this.zrbCode,
            endpoint,
            data
          )
          .subscribe((resp) => {
            console.log(resp);
            /* debugger */
            this.loading = false;
            if (resp && resp.message && resp.message == "success") {
              if (resp && resp.filePath) {
                console.log(resp.filePath);
                /* FileSaver.saveAs(resp.filePath, `filename.csv`) */
                // this.base64ToBlob(resp.filePath);
                FileSaver.saveAs(
                  this.base64ToBlob(resp.filePath),
                  data.misTypes + "-" + startDate + "_" + endDate+".xlsx"
                );
              }
            } else if (resp && resp.message && resp.message == "No Data Found") {
              const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
                width: "auto",
                height: "auto",
                data: {
                  content1: resp.message,
                  button1Text: "OK",
                },
              });
            } else if (resp && resp.message && resp.message == "Error") {
              const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
                width: "auto",
                height: "auto",
                data: {
                  content1: constants.SOMETHING_WENT_WRONG,
                  button1Text: "OK",
                },
              });
            } else {
              if (resp && resp.message) {
                const dialogRef = this.dialog.open(OpenAdminDialogYesOrNo, {
                  width: "auto",
                  height: "auto",
                  data: {
                    content1: resp.message,
                    button1Text: "OK",
                  },
                });
              }
            }
          });
      } else {
        this.snackbar.open("Please enter valid dates", "OK", { duration: 3000 });
      }
    }
    else {
      this.snackbar.open('Please enter valid dates', 'OK', { duration: 3000 })
    }



  }

  base64ToBlob(b64Data, sliceSize = 512) {
    let byteCharacters = atob(b64Data); //data.file there
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
  }

  resetForm() {
    this.misForm.reset();
    this.enableMisType = false;
    this.disableCodeDropdown = true;
    this.options = [];
  }

  selectState() {

    if(!this.selectedState){
      return
    }
    this.options = [];
    this.enableMisType = false; // require a fresh ZRB lookup after state change
    this.misForm.get('organisationName').reset();
    this.misForm.get('code').reset();
    sessionStorage.setItem(
      this.routeApiIdentifier,
      this.routeApiKeys.find((route) => route.value === this.selectedState).key
    );
    sessionStorage.setItem('stateCode', this.selectedState);
  }

}
